{
  "title": "Tourism",
  "lead": "Places to visit, trails, festivals and accredited guides and homestays.",
  "adminTitle": "Tourism",
  "adminLead": "Tourist spots, trails and visitor registration, guides and homestays, and visitor statistics.",
  "noCapability": "This office doesn't handle tourism. Ask the administrator if it should.",
  "tab_spots": "Spots",
  "tab_trails": "Trails",
  "tab_visits": "Trail visits",
  "tab_directory": "Guides & homestays",
  "tab_stats": "Statistics",
  "status_open": "Open",
  "status_temporarily_closed": "Temporarily closed",
  "status_closed": "Closed",
  "difficulty_easy": "Easy",
  "difficulty_moderate": "Moderate",
  "difficulty_challenging": "Challenging",
  "visit_booked": "Booked",
  "visit_checked_in": "Checked in",
  "visit_cancelled": "Cancelled",
  "visit_no_show": "Did not come",
  "checkin_checked_in": "Checked in",
  "checkin_already": "Already checked in",
  "checkin_not_found": "Ticket not found",
  "checkin_cancelled": "This booking was cancelled",
  "checkin_wrong_day": "Ticket for another day",
  "period_month": "Whole month",
  "period_day": "One day",
  "lastVerified": "Last verified by {office} on {date}",
  "notVerifiedYet": "Not yet verified on site by the Tourism Office.",
  "staleNote": "This was checked more than six months ago. Hours and fees may have changed; call ahead if you can.",
  "guideRequired": "Guide required",
  "registrationOpen": "Registration open",
  "photosOf": "Photos of {name}",
  "photoN": "Photo {n} {name}",
  "trailhead": "Trailhead",
  "legend": "Map legend",
  "legendTrail": "Trail",
  "legendAccess": "Road or path to the trailhead",
  "myTickets": "Your trail tickets on this phone",
  "groupOf": "Group of {count}",
  "emptyTitle": "No tourist spots or trails published yet",
  "emptyBody": "The Tourism Office will list places to visit and trails here.",
  "spotsTitle": "Places to visit",
  "trailsTitle": "Trails",
  "trailsLead": "Only trails the Tourism Office has checked on the ground are listed. Register your group before you go.",
  "eventsTitle": "Festivals and events",
  "eventsEmpty": "No upcoming festivals or events posted.",
  "seeCalendar": "See all events in the calendar",
  "directoryTitle": "Guides and homestays",
  "directoryLead": "Accredited tour guides and homestays",
  "directoryEmptyShort": "The Tourism Office hasn't listed accredited guides or homestays yet.",
  "directoryPageLead": "Accredited by the Tourism Office. Listings disappear when an accreditation expires.",
  "directoryEmpty": "No accredited guides or homestays listed yet",
  "directoryEmptyBody": "Ask the Tourism Office for accredited guides and places to stay.",
  "directoryNote": "Arrange guides and rooms directly with them. The LGU does not take bookings or payments for them.",
  "guidesTitle": "Tour guides",
  "homestaysTitle": "Homestays",
  "noGuidesListed": "No accredited guides listed.",
  "noHomestaysListed": "No accredited homestays listed.",
  "accreditedUntil": "Accreditation {no} · valid until {date}",
  "accreditationNo": "Accreditation {no}",
  "languages": "Speaks: {list}",
  "servesTrails": "Trails:",
  "capacity": "Up to {count} guests",
  "email": "Email",
  "call": "Call",
  "backToTourism": "Tourism",
  "spotNotFound": "This place isn't listed",
  "trailNotFound": "This trail isn't listed",
  "ticketNotFound": "We couldn't find that trail ticket",
  "shareText": "Shared from {app}",
  "closedNoNote": "Check with the Tourism Office before you go.",
  "visitInfo": "Visiting",
  "hours": "Opening hours",
  "fees": "Fees",
  "notStated": "Not stated. Ask the Tourism Office.",
  "howToGetThere": "How to get there",
  "mapOf": "Map showing where {name} is",
  "getDirections": "Get directions",
  "noDirections": "Directions haven't been added yet.",
  "wasteRules": "Waste rules",
  "wasteDefault": "Bring your trash home. Leave no trace.",
  "trailsHere": "Trails here",
  "trailMapOf": "Map of {name}: the trail, the way to the trailhead and the trailhead",
  "verifiedLine": "Trail line from {source}, checked on {date}.",
  "offlineHint": "Open this page once with signal: the map and your ticket are kept on the phone.",
  "rules": "Trail rules",
  "guidesForTrail": "Accredited guides for this trail",
  "noRegistration": "Registration is not open for this trail.",
  "chooseDay": "Day of your visit",
  "dayFull": "Full",
  "dayOpen": "Open",
  "slotsLeft": "{count} left",
  "bookTitle": "Register your group",
  "bookLead": "Up to {cap} visitors a day. One registration per group; the leader shows the QR code at the trailhead.",
  "guestNote": "No account needed. Have an account?",
  "groupSize": "Number of people",
  "guide": "Guide",
  "guideRequiredHint": "This trail needs an accredited guide.",
  "chooseGuide": "Choose a guide",
  "noGuide": "No guide",
  "noGuidesYet": "This trail needs a guide, but no accredited guide is listed yet. Ask the Tourism Office.",
  "leaderName": "Group leader's full name",
  "mobile": "Mobile number",
  "mobileHint": "For changes or emergencies on the trail.",
  "book": "Register",
  "booking": "Registering…",
  "chooseDayError": "Choose a day.",
  "nameError": "Enter the group leader's name.",
  "mobileError": "Enter a mobile number.",
  "guideError": "Choose a guide.",
  "consentError": "Please agree to the privacy notice.",
  "checkForm": "Please check the highlighted fields.",
  "ticketTitle": "Trail ticket",
  "ticketEyebrow": "Trail ticket",
  "bookedTitle": "You're registered",
  "bookedBody": "Show this QR code at the trailhead. It's saved on this phone, so it opens even without signal.",
  "offlineCopy": "No signal: showing the copy saved on this phone.",
  "qrAlt": "QR code for trail ticket {code}",
  "ticketCodeLabel": "Ticket code {code}",
  "date": "Date",
  "leader": "Group leader",
  "checkedInAt": "Checked in",
  "ticketHint": "One ticket covers the whole group. Arrive with everyone at the trailhead.",
  "cancelVisit": "Cancel this visit",
  "cancelTitle": "Cancel this visit?",
  "cancelBody": "Your slots go to other visitors. You can register again if there's room.",
  "cancelYes": "Yes, cancel",
  "cancelKeep": "Keep it",
  "cancelledToast": "Your visit was cancelled.",
  "manageNote": "Only the phone or account that registered can see the contact details or cancel.",
  "addSpot": "Add a spot",
  "editSpot": "Edit spot",
  "noSpotsStaff": "No tourist spots yet",
  "noSpotsStaffBody": "Add the places visitors ask about: hours, fees, how to get there and the waste rules.",
  "hidden": "Hidden",
  "markVerified": "Verified today",
  "verifiedToast": "Marked as verified today.",
  "viewPublic": "View public page",
  "savedToast": "Saved.",
  "fieldName": "Name",
  "nameRequired": "Enter a name (at least 2 characters).",
  "fieldSummary": "Short summary",
  "fieldSummaryHint": "One or two sentences shown on the card.",
  "fieldDescription": "Description",
  "fieldPhotos": "Photos",
  "fieldPhotosHint": "The first photo is the cover. Photos are compressed on the phone.",
  "fieldPin": "Location on the map",
  "fieldAccessibility": "Accessibility",
  "fieldWasteHint": "What visitors must do with their trash here.",
  "fieldStatus": "Status",
  "fieldStatusNote": "Note about the closure",
  "fieldOrder": "Order",
  "fieldOrderHint": "Lower numbers are listed first.",
  "fieldActive": "Show to the public",
  "coverPhoto": "Cover photo",
  "moveEarlier": "Move earlier",
  "moveLater": "Move later",
  "uploading": "Uploading…",
  "trailsStaffLead": "Publish a trail only with a line the office has checked on the ground (GPS track or verified survey) and the date it was checked.",
  "addTrail": "Add a trail",
  "editTrail": "Edit trail",
  "noTrailsStaff": "No trails yet",
  "noTrailsStaffBody": "Add a trail with its verified GPS line, rules and daily visitor cap.",
  "published": "Published",
  "draft": "Draft",
  "todayCount": "Today {count} / {cap}",
  "notVerifiedTrail": "No verified trail line yet, so it can't be published.",
  "fieldSpot": "Tourist spot",
  "noSpot": "Not tied to a spot",
  "fieldDifficulty": "Difficulty",
  "fieldDuration": "Usual time",
  "fieldDurationHint": "For example: 2–3 hours round trip.",
  "verifiedDataTitle": "Verified trail data",
  "verifiedDataLead": "Upload GeoJSON lines (LineString) in longitude, latitude. Use only lines the office has checked; never draw a trail from guesswork.",
  "fieldTrailLine": "Trail line",
  "fieldTrailLineHint": "GeoJSON file with the trail as a line.",
  "fieldAccessLine": "Road or path to the trailhead",
  "fieldAccessLineHint": "Optional GeoJSON line from the nearest road to the trailhead.",
  "fieldSource": "Source of the line",
  "fieldSourceHint": "Who surveyed it, e.g. \"Tourism Office GPS survey\".",
  "fieldVerifiedOn": "Checked on the ground on",
  "previewMap": "Preview of the uploaded lines",
  "fieldTrailhead": "Trailhead location",
  "fieldGuideRequired": "Visitors must have an accredited guide",
  "fieldRegistration": "Open visitor registration",
  "fieldDailyCap": "Daily visitor cap",
  "fieldDailyCapHint": "Total visitors per day across all groups.",
  "fieldPublished": "Publish this trail",
  "capRequired": "Set the daily visitor cap before opening registration.",
  "publishNeedsVerified": "To publish, add the trail line, its source and the date it was checked.",
  "chooseFile": "Choose a file",
  "replaceFile": "Replace file",
  "linesLoaded": "{count} line(s) loaded",
  "geojsonTooBig": "The file is too large. Simplify the line (fewer points) and try again.",
  "geojsonTooManyPoints": "The line has too many points. Simplify it first.",
  "geojsonInvalid": "This file can't be used: {error}",
  "trail": "Trail",
  "allTrails": "All trails",
  "checkInTitle": "Check in at the trailhead",
  "checkIn": "Check in",
  "checkInError": "Couldn't check in",
  "offlineCheckIn": "No connection. Check the group's ticket on their phone and try again when you're back online.",
  "typeCode": "Or type the ticket code",
  "cameraView": "Camera view for scanning tickets",
  "startCamera": "Scan QR code",
  "stopCamera": "Stop camera",
  "cameraDenied": "Camera access was blocked. Allow it in the browser settings, or type the code.",
  "cameraError": "The camera couldn't start. Type the ticket code instead.",
  "totalGroups": "Groups",
  "totalVisitors": "Visitors",
  "totalCheckedIn": "Checked in",
  "totalNoShow": "No-shows",
  "exportCsv": "Export CSV",
  "noVisits": "No trail visits for this day",
  "checkedInAtTime": "Checked in at {time}",
  "markNoShow": "Didn't come",
  "undo": "Undo",
  "addGuide": "Add a guide",
  "editGuide": "Edit guide",
  "noGuidesStaff": "No guides yet",
  "expired": "Expired",
  "addHomestay": "Add a homestay",
  "editHomestay": "Edit homestay",
  "noHomestaysStaff": "No homestays yet",
  "homestayListedRule": "A homestay is listed publicly only with an accreditation number and a validity date that hasn't passed.",
  "notAccredited": "No accreditation entered",
  "listed": "Listed",
  "notListed": "Not listed",
  "accreditationRequired": "Enter the accreditation number.",
  "untilRequired": "Enter the date the accreditation ends.",
  "fieldAccreditationNo": "Accreditation number",
  "fieldAccreditedUntil": "Accredited until",
  "fieldAccreditedUntilHint": "The guide is hidden from the public after this date.",
  "fieldLanguages": "Languages",
  "fieldLanguagesHint": "Separate with commas, e.g. English, Filipino, Ilocano.",
  "fieldTrailsServed": "Trails this guide serves",
  "fieldPhone": "Phone",
  "fieldGuidePhoto": "Photo",
  "fieldNotes": "Notes",
  "fieldNotesHint": "Shown to the public.",
  "fieldAddress": "Address",
  "fieldCapacity": "Guests",
  "homestayAccreditationHint": "Needed for the homestay to appear publicly.",
  "from": "From",
  "to": "To",
  "rangeHint": "Leave empty for the last 12 months.",
  "enterCount": "Enter a visitor count",
  "enterCountLead": "For a place, a day or a whole month. Entering the same place and period again replaces the earlier count. A monthly count replaces that month's daily counts in the totals.",
  "place": "Place",
  "otherPlaces": "Other places / all",
  "periodType": "Count for",
  "monthField": "Month",
  "monthFieldHint": "Any day in the month.",
  "dayField": "Day",
  "totalVisitorsField": "Total visitors",
  "totalRequired": "Enter the total number of visitors.",
  "residents": "Residents",
  "nonResidents": "Non-residents",
  "foreign": "Foreign",
  "saveCount": "Save count",
  "countSaved": "Count saved.",
  "enteredVisitors": "Visitors (entered counts)",
  "trailVisitors": "Trail visitors (checked in)",
  "statsRange": "{from} to {to}",
  "exportStats": "Export for DOT report (CSV)",
  "chartByMonth": "Visitors by month (entered counts)",
  "chartTrailByMonth": "Trail visitors by month (checked in)",
  "chartByPlace": "Visitors by place",
  "visitors": "Visitors",
  "showTable": "Show table",
  "hideTable": "Show chart",
  "noData": "No visitors counted in this period.",
  "colPeriodPlace": "Month or place",
  "enteredCounts": "Entered counts",
  "noCounts": "No counts entered for this period",
  "colPeriod": "Period",
  "colSplit": "Breakdown",
  "deleteCount": "Delete this count",
  "myVisits": "My trail visits"
}
